import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LocalStorage } from '../utils/LocalStorage';
import './OverduePaymentBanner.scss';

const REFRESH_INTERVAL_MS = 5000;

export const OverduePaymentBanner = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [active, setActive] = useState(false);

    useEffect(() => {
        const readFromStorage = () => {
            setActive(LocalStorage.fetchHasPaymentSuspensionWarning());
        };

        readFromStorage();
        const interval = setInterval(readFromStorage, REFRESH_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    if (!active) return null;

    const handleCtaClick = () => {
        navigate('/agency/subscription#pending-payments');
    };

    return (
        <div className="overdue-payment-banner" role="alert" aria-live="polite">
            <div className="overdue-payment-banner-content">
                <span className="overdue-payment-banner-dot" aria-hidden="true"></span>
                <span className="overdue-payment-banner-eyebrow">
                    {t('overdue_payment_banner.eyebrow')}
                </span>
                <span className="overdue-payment-banner-text">
                    {t('overdue_payment_banner.message')}
                </span>
                <button className="overdue-payment-banner-cta" onClick={handleCtaClick}>
                    {t('overdue_payment_banner.cta')}
                    <FontAwesomeIcon
                        icon={faArrowRight}
                        className="overdue-payment-banner-cta-arrow"
                        aria-hidden="true"
                    />
                </button>
            </div>
        </div>
    );
};
